import React from "react";
import PropTypes from "prop-types";
import { Grid, GridItem } from "@sainsburys-tech/fable";
import StoreZoneListItem from "./StoreZoneListItem";
import getZoneSortIdx from "../../model/store-commissioning/getZoneSortOrder";

const StoreZoneList = props => (
  <Grid cols={{ xs: 2, sm: 2, md: 3, lg: 3, xl: 3 }}>
    {props.zonesConfiguration
      .sort((a, b) => {
        return (
          getZoneSortIdx(a.zone.zoneType) - getZoneSortIdx(b.zone.zoneType)
        );
      })
      .map((zoneConfiguration, index) => {
        return (
          <GridItem
            colSpan={{ xs: 1, sm: 1, md: 1, lg: 1, xl: 1 }}
            key={index}
          >
            <StoreZoneListItem
              zoneConfiguration={zoneConfiguration}
              storeId={props.storeId}
              deleteStoreZone={props.deleteStoreZone}
              editStoreZone={props.editStoreZone}
            />
          </GridItem>
        );
      })}
  </Grid>
);

StoreZoneList.propTypes = {
  zonesConfiguration: PropTypes.arrayOf(
    PropTypes.shape({
      zone: PropTypes.shape({
        zoneId: PropTypes.string,
        name: PropTypes.string
      }),
      scenes: PropTypes.arrayOf(
        PropTypes.shape({
          scene: PropTypes.shape({
            name: PropTypes.string,
            description: PropTypes.string
          }),
          sceneLevel: PropTypes.string
        })
      )
    })
  ).isRequired,
  scenes: PropTypes.arrayOf(
    PropTypes.shape({
      scene: PropTypes.shape({
        name: PropTypes.string,
        description: PropTypes.string
      }),
      sceneLevel: PropTypes.string
    })
  ),
  storeId: PropTypes.string,
  deleteStoreZone: PropTypes.func,
  editStoreZone: PropTypes.func,
  featureLightingGroupId: PropTypes.number,
  counterLightingGroupId: PropTypes.number
};

export default StoreZoneList;
